import React from 'react';
import { X, CheckCircle } from 'lucide-react';
import { useUI } from '../../context/AppContext';
import { Z_INDEX } from '../../utils/constants';

const NotificationToast = () => {
  const { notificationMsg } = useUI();
  if (!notificationMsg) return null;
  return (
    <div
      className={`print:hidden fixed top-[calc(1.25rem_+_env(safe-area-inset-top))] right-[max(1.25rem,env(safe-area-inset-right))] left-[max(1.25rem,env(safe-area-inset-left))] sm:left-auto px-6 py-4 rounded-2xl shadow-2xl text-white font-bold animate-in slide-in-from-right flex items-center gap-3 ${
        notificationMsg.type === 'error' ? 'bg-red-500' : 'bg-emerald-500'
      }`}
      style={{ zIndex: Z_INDEX.toast }}
    >
      {notificationMsg.type === 'error' ? <X size={20} /> : <CheckCircle size={20} />}
      {notificationMsg.msg}
    </div>
  );
};

export default NotificationToast;
